export default {
  financialAudit: {
    text: '财务审核中',
    color: '#e80000'
  },
  financialMaintain: {
    text: ' 财务维护中',
    color: '#e80000'
  },
  tobeConfirmed: {
    text: '待确认',
    color: '#e80000'
  },
  refuseto: {
    text: '财务驳回',
    color: '#e80000'
  },
  ProcessCompletion: {
    text: '流程完成',
    color: '#e80000'
  },
  cancel: {
    text: '已取消',
    color: '#e80000'
  },
  suporting: {
    text: '支持中',
    color: '#e80000'
  },
  leave: {
    text: '已离职',
    color: '#e80000'
  },
  created: {
    text: '流程创建',
    color: '#e80000'
  }
};